module.exports = ".margin-top-10{\n    margin-top: 10px;\n}\n.btn-wrapper{\n    text-align: center;\n}\n.min-width-120{\n    min-width: 120px;\n}\n.initiate-price-container {\n    display: flow-root;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal/catalog-modal/catalog-modal.component.css
// module id = ./src/app/shared/components/modal/catalog-modal/catalog-modal.component.css
// module chunks = main